import { createFileRoute } from '@tanstack/react-router';
import { BusinessLinesSettingsPage } from '../features/settings/BusinessLinesSettingsPage';

export const Route = createFileRoute('/settings/business-lines')({
  component: BusinessLinesSettingsPage,
});
